import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconPulseComponent } from "./med-icon-pulse.component";

@NgModule({
  declarations: [
    MedIconPulseComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconPulseComponent,
  ],
})
export class MedIconPulseModule { }
